import React from 'react';
import logo from './logo.png';
import './App.css';
import './MainBanner.css'
import Typing from 'react-typing-animation';

function MainBanner() {
    return (
        <div className="MainBanner">

            <span id="welcomeText">Hello There!</span>

          <Typing loop speed={75}>
            <span id="welcomeText">I'm Safiyah.</span>
            <Typing.Reset count={2} delay={3000}/>
          </Typing>

          <img src={logo} id="MainBannerPic"/>
            <div className="arrow-down">
              <a ><svg version="1.1" width="49px" height="25px"><polygon fill-rule="evenodd" clip-rule="evenodd" fill="#000" points="49.01,0.706 48.294,-0.01 24.5,23.784 0.706,-0.01 -0.01,0.706 24.294,25.01 24.5,24.804 24.706,25.01"/></svg></a>
            </div>
        </div>
      );

}

export default MainBanner;